module.exports = __webpack_public_path__ + "img/product-placeholder-47.06df6a1.png";